"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsSignupTypeEnum = void 0;
var AnalyticsSignupTypeEnum;
(function (AnalyticsSignupTypeEnum) {
    AnalyticsSignupTypeEnum["SIGNUP"] = "signup";
    AnalyticsSignupTypeEnum["INVITE"] = "invite";
})(AnalyticsSignupTypeEnum || (exports.AnalyticsSignupTypeEnum = AnalyticsSignupTypeEnum = {}));
